import dayjs from 'dayjs'

export default function dateFormatter(date) {
    const dateIsvalid = dayjs(date).isValid()
    if (dateIsvalid) {
        return dayjs(date).format('DD/MM/YYYY')
    } else if (typeof date === 'string' && date.includes('/')) {
        return date
    }
}
